import { clsx } from "clsx";
import type { CSSProperties, ReactNode } from "react";

interface GridContainerProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

/**
 * Responsive grid container providing 12/8/4 column layout.
 *
 * Breakpoints:
 * - Desktop (≥1280px): 12 columns, 32px gap, 64px margin
 * - Tablet (768-1279px): 8 columns, 24px gap, 32px margin
 * - Mobile (<768px): 4 columns, 16px gap, 16px margin
 */
export function GridContainer({ children, className, style }: GridContainerProps) {
  return (
    <div
      style={style}
      className={clsx(
        "w-full max-w-[1440px] mx-auto",
        // Mobile: 4 columns, 16px gap, 24px padding
        "grid grid-cols-4 gap-4 px-6",
        // Tablet: 8 columns, 24px gap, 64px padding
        "md:grid-cols-8 md:gap-6 md:px-16",
        // Desktop: 12 columns, 32px gap, 180px padding (~2 columns inset)
        "xl:grid-cols-12 xl:gap-8 xl:px-[180px]",
        className,
      )}
    >
      {children}
    </div>
  );
}
